var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React from 'react';
import { BodyTemplate, TableComponent, useEntireLoader } from 'renderer/components';
import Image from 'antd/lib/image';
import { useDebounce } from 'renderer/utils';
import { formmatPhoneNumber } from './migrationUtils';
import Select from 'antd/lib/select';
import { StoreReviewQuery } from 'renderer/queries';
import dayjs from 'dayjs';
import { StoreReviewModel } from '../../models/StoreReviewModel';
import Row from 'antd/lib/row';
import Input from 'antd/lib/input/Input';
import Col from 'antd/lib/col';
export var AdminReview = function (props) {
    var loader = useEntireLoader();
    var _a = StoreReviewQuery.useAdminReviewHistoryPager({
        page: 1,
        limit: 10
    }), pagerResult = _a.pagerResult, getPaginateObject = _a.getPaginateObject, setNewPagerOptions = _a.setNewPagerOptions, pagerOptions = _a.pagerOptions;
    var _b = React.useState('all'), status = _b[0], setStatus = _b[1];
    var _c = React.useState(''), keyword = _c[0], setKeyword = _c[1];
    var mutation = StoreReviewQuery.useUpdateReviewStatusForAdmin();
    var debouncedKeyword = useDebounce(keyword, 500);
    React.useEffect(function () {
        console.log('debouncedKeyworddebouncedKeyword', debouncedKeyword);
        var keyword = pagerOptions.keyword;
        var newStatus = pagerOptions.status;
        if (debouncedKeyword !== pagerOptions.keyword) {
            keyword = debouncedKeyword;
        }
        if (status !== pagerOptions.status) {
            console.log('같이 여기오냐??');
            newStatus = status === 'all' ? undefined : status;
        }
        setNewPagerOptions(__assign(__assign({}, pagerOptions), { keyword: keyword, status: newStatus }));
    }, [debouncedKeyword, status]);
    var columns = [
        {
            title: '상점아이디',
            dataIndex: 'store.id',
            key: 'store.id',
            render: function (_, row) {
                var _a;
                return "".concat((_a = row === null || row === void 0 ? void 0 : row.store) === null || _a === void 0 ? void 0 : _a.id);
            }
        },
        {
            title: '상점명',
            dataIndex: 'store.name',
            key: 'store.name',
            render: function (_, row) {
                var _a;
                return "".concat((_a = row === null || row === void 0 ? void 0 : row.store) === null || _a === void 0 ? void 0 : _a.name);
            }
        },
        {
            title: '매출아이디',
            dataIndex: 'salesHistoryId',
            key: 'salesHistoryId',
            render: function (_, row) {
                return "".concat(row === null || row === void 0 ? void 0 : row.salesHistoryId);
            }
        },
        {
            title: '고객',
            dataIndex: 'customer',
            key: 'customer',
            width: 150,
            render: function (_, row) {
                var _a, _b, _c;
                return ((_a = row === null || row === void 0 ? void 0 : row.customer) === null || _a === void 0 ? void 0 : _a.name) ? "".concat((_b = row === null || row === void 0 ? void 0 : row.customer) === null || _b === void 0 ? void 0 : _b.name, "(").concat(formmatPhoneNumber((_c = row === null || row === void 0 ? void 0 : row.customer) === null || _c === void 0 ? void 0 : _c.phone), ")") : '-';
            }
        },
        {
            title: '스샷',
            dataIndex: 'content.screenshot',
            key: 'content.screenshot',
            width: 150,
            render: function (_, row) {
                var _a, _b;
                return ((_a = row.content) === null || _a === void 0 ? void 0 : _a.screenshot) ? React.createElement(Image, { width: 50, src: (_b = row.content) === null || _b === void 0 ? void 0 : _b.screenshot }) : '-';
            }
        },
        {
            title: '요청일(리뷰작성일)',
            dataIndex: 'createdAt',
            key: 'createdAt',
            width: 250,
            render: function (_, row) {
                return "".concat(row.createdAt ? dayjs(row.createdAt).format('YYYY-MM-DD HH:mm') : '-', "(").concat(row.uploadedAt ? dayjs(row === null || row === void 0 ? void 0 : row.uploadedAt).format('YYYY-MM-DD HH:mm') : '-', ")");
            }
        },
        {
            title: '상태',
            dataIndex: 'status',
            key: 'status',
            width: 150,
            render: function (_, row) {
                if ([StoreReviewModel.REVIEW_STATUS.PENDING, StoreReviewModel.REVIEW_STATUS.PAID_FAIL].includes(row.status)) {
                    return (React.createElement(Select, { style: { width: '100%' }, id: "demo-simple-select-helper", value: row.status, options: row.status === StoreReviewModel.REVIEW_STATUS.PENDING
                            ? [
                                { label: '검수중', value: StoreReviewModel.REVIEW_STATUS.PENDING, disabled: true },
                                { label: '승인', value: StoreReviewModel.REVIEW_STATUS.APPROVED },
                                { label: '거절', value: StoreReviewModel.REVIEW_STATUS.REJECTED }
                            ]
                            : [
                                { label: '과금완료', value: StoreReviewModel.REVIEW_STATUS.PAID },
                                { label: '과금실패', value: StoreReviewModel.REVIEW_STATUS.PAID_FAIL, disabled: true }
                            ], onChange: function (value) { return __awaiter(void 0, void 0, void 0, function () {
                            var err_1;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        loader.show();
                                        _a.label = 1;
                                    case 1:
                                        _a.trys.push([1, 3, 4, 5]);
                                        return [4 /*yield*/, mutation.mutateAsync({ id: row.id, status: value })];
                                    case 2:
                                        _a.sent();
                                        return [3 /*break*/, 5];
                                    case 3:
                                        err_1 = _a.sent();
                                        return [3 /*break*/, 5];
                                    case 4:
                                        loader.hide();
                                        return [7 /*endfinally*/];
                                    case 5: return [2 /*return*/];
                                }
                            });
                        }); } }));
                }
                else {
                    return row.statusString;
                }
            }
        }
    ];
    return (React.createElement(BodyTemplate, { title: "\uB9AC\uBDF0\uAD00\uB9AC", content: React.createElement("div", { style: { height: 'calc(100% - 50px)', overflow: 'scroll', marginBottom: '30px' } },
            React.createElement(Row, { style: { marginTop: '10px', marginBottom: '20px' }, gutter: 8 },
                React.createElement(Col, { span: 4 },
                    React.createElement(Select, { style: { width: '100%' }, id: "demo-simple-select-helper", value: status, options: [
                            { label: '전체', value: 'all' },
                            { label: '요청', value: StoreReviewModel.REVIEW_STATUS.REQUESTED },
                            { label: '검수중', value: StoreReviewModel.REVIEW_STATUS.PENDING },
                            { label: '거절', value: StoreReviewModel.REVIEW_STATUS.REJECTED },
                            { label: '과금완료', value: StoreReviewModel.REVIEW_STATUS.PAID },
                            { label: '과금실패', value: StoreReviewModel.REVIEW_STATUS.PAID_FAIL }
                        ], onChange: function (value) { return __awaiter(void 0, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                setStatus(value);
                                return [2 /*return*/];
                            });
                        }); } })),
                React.createElement(Col, { span: 8 },
                    React.createElement(Input, { value: keyword, onChange: function (e) { return setKeyword(e.target.value); }, placeholder: "\uC0C1\uC810\uBA85, \uACE0\uAC1D\uBA85,\uACE0\uAC1D\uBC88\uD638 \uAC80\uC0C9" }))),
            React.createElement(TableComponent, { pagination: getPaginateObject(), columns: columns, rowKey: function (row) { return row.id; }, scroll: { y: 800 }, dataSource: pagerResult.items || [] })) }));
};
